module.exports = __webpack_public_path__ + "img/icon_lb.5ebcc253.png";